export default __webpack_public_path__ + "static/media/srmLogo.76244449.png";